// extracted by mini-css-extract-plugin
module.exports = {"navButton":"styles_navButton__2Wn2s","variant-secondary":"styles_variant-secondary__ZqG8M","variantSecondary":"styles_variant-secondary__ZqG8M","disabled":"styles_disabled__-R6Ob"};